import $ from "jquery";

const faqAccordion = {
  variable:{
    url: window.location.href,
  },
  element: {
    loadMoreClick: $(".accordion_faq_loadmore"),
    faqAccordionFirst: $(".faqAccordion").eq(0),
    faqAccordionSecond: $(".faqAccordion").eq(1)

  },
  method: {
    loadMoreFaqs: function () {
      faqAccordion.element.loadMoreClick.on("click", function () {
        let faqComp = $(this).parents(".faqAccordion");
        let counter = parseInt($(this).attr("data-counter"));
        let count = faqComp.find(`.accordion_faq_item`).length;
        let limit = parseInt($(this).attr("data-limit"));
        for (let i = counter + 1; i <= counter + limit; i++) {
          faqComp
            .find(`.accordion_faq_item:eq(${i - 1})`)
            .toggleClass("d-none d-block");
        }
        counter += limit;
        $(this).attr("data-counter", counter);
        if (counter >= count) {
          $(this).hide();
        }
      });
    },
    addSpace: function(){
      if($(window).width() > 768){
        faqAccordion.element.faqAccordionFirst.css('padding-right','10px');
        faqAccordion.element.faqAccordionSecond.css('padding-left','10px');
      }

    },

    loadAccordionClickHandler: function () {
     $('.accordion_faq').on('click', '.accordion-button.accordion_faq_button', function () {

        let faqAccordionContainer = $(this).closest('.faqAccordion');
        let titleText = null;
        let question = null;
            if (faqAccordionContainer.length) {
                let container = faqAccordionContainer.closest('.genericContainer');

                if (container.length) {
                    let chliTitleElement = container.find('.chlititle').first();
                    if (chliTitleElement.length) {
                         titleText = chliTitleElement.text().trim();
                    }
                }if(titleText==null){
                 let parentSection = faqAccordionContainer.closest('section.faq').find('.faq_tabs').find('.faq_tabs--list');
                          if (parentSection.length) {
                           let faqTitleElement = parentSection.find(".cmp-tabs__tab--active");
                           if (faqTitleElement.length) {
                               titleText = faqTitleElement.text().trim();
                           }
                       }
                }if(titleText==null){
                  let chliTitleContainer = faqAccordionContainer.closest('.genericContainer');

                  if(chliTitleContainer.length){
                    let titleElement = chliTitleContainer.siblings('.genericContainer').last();
                    if(titleElement.length){
                       titleText = titleElement.find('.chlititle').text().trim();
                    }
                  }
                }
            }

        if (!$(this).hasClass('collapsed')) {
          let obj = faqAccordion.method.dataLayerObj($(this),titleText,$(this));
          createDataLayer('Expand', obj);
        }
      });
    },

    loadMoreClickHandler: function(){
      $('.faqAccordion ').on('click','.accordion_faq_loadmore',function() {

        let faqAccordionContainer = $(this).closest('.faqAccordion');
        let titleText = null;
         if (faqAccordionContainer.length) {
           let container = faqAccordionContainer.closest('.genericContainer');
           if (container.length) {
             let chliTitleElement = container.find('.chlititle').first();
               if (chliTitleElement.length) {
                  titleText = chliTitleElement.text().trim();
               }
               }if(titleText==null){
                 let parentSection = faqAccordionContainer.closest('section.faq').find('.faq_tabs').find('.faq_tabs--list');
                 if (parentSection.length) {
                  let faqTitleElement = parentSection.find(".cmp-tabs__tab--active");
                      if (faqTitleElement.length) {
                        titleText = faqTitleElement.text().trim();
                      }
                 }
               }if(titleText==null){
                 let chliTitleContainer = faqAccordionContainer.closest('.genericContainer');

                 if(chliTitleContainer.length){
                    let titleElement = chliTitleContainer.siblings('.genericContainer').last();
                    if(titleElement.length){
                       titleText = titleElement.find('.chlititle').text().trim();
                    }
                 }
               }
         }
        let obj = faqAccordion.method.dataLayerObj($(this),titleText,null);
        createDataLayer('buttonClick', obj);
      });
    },

    dataLayerObj: function (el,e,q) {
      var obj = {
        'articleName': "",
        'blogCategory': "",
        'blogPageCategory': "",
        'buttonText': el ? el.text().replace(/\n/g, '').trim() : "",
        'pageSection': e ? e : "",
        'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? faqAccordion.variable.url.includes("blog") ? "Blogs" : faqAccordion.variable.url.substring(faqAccordion.variable.url.indexOf(".com/"), faqAccordion.variable.url.lastIndexOf('/')  === ".com") && !faqAccordion.variable.url.substring(faqAccordion.variable.url.indexOf(".com/"), faqAccordion.variable.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
        'planOption': "",
        'productCategory': document.getElementById('productCategoryName') ? document.getElementById('productCategoryName').value : "",
        'productName': document.getElementById('productPlanName') ? document.getElementById('productPlanName').value : "",
        'question': q ? q.text().replace(/\n/g, '').trim() : "",
        'source': "",
        'leadForm': "",
        'searchTerm': "",
        'videoTitle': "",
        'bannerName': "",
      };
      return obj;
    },
  },
};

$(() => {
    if ($(".faqAccordion").length > 0) {
        faqAccordion.method.loadMoreFaqs();
        faqAccordion.method.addSpace();
    }
  });
// Document ready handler
$(document).ready(function () {
  faqAccordion.method.loadAccordionClickHandler();
  faqAccordion.method.loadMoreClickHandler();
});
